import React from 'react';

const Footer = () => (
  <footer style={{
    marginTop: 'auto',
    padding: '24px 20px',
    borderTop: '1px solid var(--border-subtle)',
    textAlign: 'center',
    color: 'var(--text-muted)',
    fontSize: 13
  }}>
    <div style={{ maxWidth: 1400, margin: '0 auto' }}>
      © {new Date().getFullYear()} Dreamlifeway. All rights reserved.
    </div>
  </footer>
);

export default Footer;
